import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration, updateSiteConfigs } from 'actions/Site'
import { fetchAutoDebitLogPayment, exportFile } from 'actions/AutoDebitLogPayment'
import AutoDebitLogPaymentView from 'components/pages/autoDebit/logPayment/List'
import { pickBy, identity } from 'lodash'
import qs from 'query-string'
import { message } from 'antd'
import history from 'utils/history'

export function mapStateToProps(state) {
  const {
    isFetching,
    dataAutoDebitLogPayment,
    metaAutoDebitLogPayment,
  } = state.root.autoDebitLogPayment

  return {
    isFetching,
    dataAutoDebitLogPayment,
    metaAutoDebitLogPayment,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchAutoDebitLogPayment: bindActionCreators(fetchAutoDebitLogPayment, dispatch),
  exportFile: bindActionCreators(exportFile, dispatch),
})

const dataStatus = [
  { id: 1, label: 'Draft', value: 'draft' },
  { id: 2, label: 'Confirmed', value: 'confirmed' },
  { id: 3, label: 'Settled', value: 'settled' },
  { id: 4, label: 'In Progress', value: 'in progress' },
  { id: 4, label: 'Failed', value: 'failed' },
]

const dataStatusFrekuensi = [
  { id: 1, label: 'Bulanan', value: 'bulanan' },
  { id: 2, label: 'Tahunan', value: 'tahunan' },
]

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('statusList', 'setStatusList', dataStatus),
  withState('statusFrekuensiList', 'setStatusFrekuensiList', dataStatusFrekuensi),
  withState('dataFile', 'setDataFile', ''),
  withState('paramsFile', 'setParamsFile', ''),
  withState('stateSearch', 'setStateSearch', {}),
  withState('isExport', 'setIsExport', false),
  withHandlers({
    onLoad: props => (isSearch) => {
      const {
        page, search, status, frekuensi, startDate, endDate,
      } = props.stateSearch
      const payload = {
        page: isSearch ? '' : page,
        search: search || '',
        status: status || '',
        deposit_frequency: frekuensi || '',
        start_date: startDate || '',
        end_date: endDate || '',
      }
      props.setParamsFile(`?${qs.stringify(pickBy(payload, identity))}`)
      props.fetchAutoDebitLogPayment(`?${qs.stringify(pickBy(payload, identity))}`)
    },
  }),
  withHandlers({
    handleReport: props => () => {
      const { paramsFile, setIsExport } = props
      setIsExport(true)
      props.exportFile(paramsFile)
        .then((result) => {
          if (result) {
            setIsExport(false)
            history.push('/download')
          } else {
            message.error('Something when wrong')
          }
        }).catch((error) => {
          message.error(error)
          setIsExport(false)
        })
    },
    handleSearch: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        search: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handleChangeStatus: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        status: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handleChangeStatusFrekuensi: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        frekuensi: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handleChangeDate: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      let start = ''
      let end = ''
      if (val.length === 2) {
        start = val[0].format('DD-MM-YYYY')
        end = val[1].format('DD-MM-YYYY')
      } else {
        start = ''
        end = ''
      }
      setStateSearch({
        ...stateSearch,
        startDate: start,
        endDate: end,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handlePage: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        page: val,
      })
      setTimeout(() => {
        onLoad()
      }, 300)
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Autodebet', 'Log Payment', 'List'])
      this.props.updateSiteConfigs({
        titlePage: 'Autodebet - Log Payment',
        activePage: 'auto-debet/log-payment',
        activeSubPage: 'log-payment',
      })
      this.props.fetchAutoDebitLogPayment()
    },
  }),
)(AutoDebitLogPaymentView)
